<template>
  <v-container v-if="user" fluid>
    <v-card>
      <v-col>
        <v-card-title>
          Pedidos
          <v-spacer />
          <v-btn color="primary" icon @click="tourDriver">
            <v-icon>mdi-help-circle</v-icon>
          </v-btn>
        </v-card-title>
        <v-row>
          <v-col cols="auto">
            <v-btn
              :class="[
                {
                  'disabled-button': selectedOption != 'abiertos',
                  'enabled-button': selectedOption === 'abiertos',
                },
                'mr-1',
                'ml-2',
                'mb-1',
              ]"
              color="primary"
              @click="selectedOption = 'abiertos'"
              id="pedidos-abiertos"
            >
              Abiertos
            </v-btn>
            <v-btn
              :class="[
                {
                  'disabled-button': selectedOption != 'cerrados',
                  'enabled-button': selectedOption === 'cerrados',
                },
                'mr-1',
                'ml-2',
                'mb-1',
              ]"
              color="primary"
              @click="selectedOption = 'cerrados'"
              id="pedidos-cerrados"
            >
              Cerrados
            </v-btn>
            <!-- 
            <v-btn
              :class="[
                {
                  'disabled-button': selectedOption != 'transfers',
                  'enabled-button': selectedOption === 'transfers',
                },
                'mr-1',
                'ml-2',
                'mb-1',
              ]"
              color="primary"
              @click="selectedOption = 'transfers'"
              id="transfers-component"
            >
              Transfers
            </v-btn>
            -->
            <v-btn
              v-if="permisoAreaTrabajo"
              :class="[
                {
                  'disabled-button': selectedOption != 'areaTrabajo',
                  'enabled-button': selectedOption === 'areaTrabajo',
                },
                'mr-1',
                'ml-2',
                'mb-1',
              ]"
              color="primary"
              @click="selectedOption = 'areaTrabajo'"
              id="area-trabajo"
            >
              Área de trabajo
            </v-btn>
          </v-col>

          <!-- Botones de Vistas con texto flotante -->
          <v-col cols="auto" class="position-relative d-flex align-center">
            <div style="position: relative">
              <!-- Texto "Vistas" flotante arriba -->
              <div
                style="
                  position: absolute;
                  top: -25px;
                  left: 50%;
                  transform: translateX(-50%);
                  text-align: center;
                "
              >
                <h4 class="mb-0">Vistas</h4>
              </div>
              <!-- Botones -->
              <div class="d-flex flex-wrap">
                <v-btn
                  v-if="esSucursal2"
                  :class="[
                    selectedOption != 'confirmados'
                      ? 'disabled-button'
                      : 'enabled-button',
                    'mr-1',
                    'ml-2',
                    'mb-1',
                  ]"
                  color="primary"
                  @click="selectedOption = 'confirmados'"
                  id="pedidos-confirmados"
                >
                  Confirmación
                </v-btn>
                <v-btn
                  v-if="esSucursal"
                  :class="[
                    selectedOption != 'confirmados2'
                      ? 'disabled-button'
                      : 'enabled-button',
                    'mr-1',
                    'ml-2',
                    'mb-1',
                  ]"
                  color="primary"
                  @click="selectedOption = 'confirmados2'"
                  id="pedidos-confirmados"
                >
                  Confirmación
                </v-btn>
                <v-btn
                  :class="[
                    selectedOption != 'facturacion'
                      ? 'disabled-button'
                      : 'enabled-button',
                    'mr-1',
                    'ml-2',
                    'mb-1',
                  ]"
                  color="primary"
                  @click="selectedOption = 'facturacion'"
                  id="pedidos-preparacion"
                >
                  Facturación
                </v-btn>
                <v-btn
                  :class="[
                    selectedOption != 'ruta'
                      ? 'disabled-button'
                      : 'enabled-button',
                    'mr-1',
                    'ml-2',
                    'mb-1',
                  ]"
                  color="primary"
                  @click="selectedOption = 'ruta'"
                >
                  Ruta de Entrega
                </v-btn>
                <!-- 
                <v-btn
                  v-if="esAdmin"
                  :class="[
                    selectedOption != 'preparacion'
                      ? 'disabled-button'
                      : 'enabled-button',
                    'mr-1',
                    'ml-2',
                    'mb-1',
                  ]"
                  color="primary"
                  @click="selectedOption = 'preparacion'"
                  id="pedidos-preparacion"
                >
                  Preparación
                </v-btn>
                -->
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row
          v-if="selectedOption === ''"
          class="text-center"
          justify="center"
        >
          <v-progress-circular
            class="my-10"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-row>
        <v-row>
          <PedidosAbiertosTable
            v-if="selectedOption === 'abiertos'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            @pedidoModificado="pedidoModificado"
            @pedidoEntregado="pedidoEntregado"
            @pedidosActualizados="recibirPedidosActualizados"
          />
          <!-- <GraphComponent v-if="selectedOption === 'cerrados'" /> -->
          <PedidosCerradosTable
            v-if="selectedOption === 'cerrados'"
            :items="itemsCerrados"
            :usuarios="usuarios"
            :clientes="clientes"
          />
          <TransfersComponent
            v-if="selectedOption === 'transfers'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            :transfers="transfers"
            @setTransfers="setTransfers"
          />
          <AreaTrabajo
            v-if="selectedOption === 'areaTrabajo'"
            @solicitarPedidos="actualizarPedidos"
            :productos="productos"
            :usuarios="usuarios"
            :clientes="clientes"
          />
          <PedidosConfirmacion
            v-if="selectedOption === 'confirmados'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            @pedidoModificado="pedidoModificado"
            @pedidoEntregado="pedidoEntregado"
            @pedidosActualizados="recibirPedidosActualizados"
          />
          <PedidosConfirmados2
            v-if="selectedOption === 'confirmados2'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            @pedidoModificado="pedidoModificado"
            @pedidoEntregado="pedidoEntregado"
            @pedidosActualizados="recibirPedidosActualizados"
          />
          <PedidosFacturacion
            v-if="selectedOption === 'facturacion'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            @pedidoModificado="pedidoModificado"
            @pedidoEntregado="pedidoEntregado"
            @pedidosActualizados="recibirPedidosActualizados"
          />
          <PedidosRuta
            v-if="selectedOption === 'ruta'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            @pedidoModificado="pedidoModificado"
            @pedidoEntregado="pedidoEntregado"
            @pedidosActualizados="recibirPedidosActualizados"
          />
          <!--
          <PedidosPreparacion
            v-if="selectedOption === 'preparacion'"
            :items="items"
            :usuarios="usuarios"
            :clientes="clientes"
            @pedidoModificado="pedidoModificado"
            @pedidoEntregado="pedidoEntregado"
            @pedidosActualizados="recibirPedidosActualizados"
          />
          -->
        </v-row>
      </v-col>
    </v-card>
  </v-container>
</template>

<script>
import PedidosAbiertosTable from "@/components/PedidosAbiertosTable.vue";
import PedidosCerradosTable from "@/components/PedidosCerradosTable.vue";
import AreaTrabajo from "@/components/AreaTrabajo.vue";
//import PedidosConfirmados from "@/components/PedidosConfirmados(NoUse).vue";
import PedidosConfirmacion from "@/components/PedidosConfirmacion.vue";
import PedidosConfirmados2 from "@/components/PedidosConfirmados2.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import TransfersComponent from "@/components/TransfersComponent.vue";
import PedidosFacturacion from "@/components/PedidosFacturacion.vue";
//import PedidosPreparacion from "@/components/PedidosPreparacion.vue";
import { driver } from "driver.js";
import "driver.js/dist/driver.css";
import PedidosRuta from "@/components/PedidosRuta.vue";

export default {
  data: () => ({
    selectedOption: "",
    items: [],
    clientes: [],
    usuarios: [],
    itemsCerrados: [],
    transfers: [],
    permisoAreaTrabajo: false,
  }),
  methods: {
    tourDriver() {
      const driverObj = driver({
        showProgress: true,
        progressText: "paso {{current}} de {{total}}",
        doneBtnText: "Finalizar",
        nextBtnText: "Siguiente",
        prevBtnText: "Anterior",
        closeBtnText: "Cerrar",
        popoverClass: "glass-effect",
        steps: [
          {
            element: "#pedidos-abiertos",
            popover: {
              title: "Pedidos Abiertos",
              description: "Aquí puedes ver y gestionar los pedidos abiertos.",
              position: "bottom",
            },
          },
          {
            element: "#pedidos-cerrados",
            popover: {
              title: "Pedidos Cerrados",
              description:
                "Aquí puedes ver los pedidos que ya han sido cerrados.",
              position: "bottom",
            },
          },
          {
            element: "#area-trabajo",
            popover: {
              title: "Área de Trabajo",
              description: "Aquí puedes crear, ver y gestionar tus pedidos.",
              position: "bottom",
            },
          },
          {
            element: "#pedidos-confirmados",
            popover: {
              title: "Pedidos Confirmados",
              description:
                "Aquí puedes ver y gestionar solo los pedidos que han sido confirmados.",
              position: "bottom",
            },
          },
          {
            element: "#pedidos-facturacion",
            popover: {
              title: "Facturación de Pedidos",
              description:
                "Aquí puedes gestionar la facturación de los pedidos.",
              position: "bottom",
            },
          },
        ],
      });
      driverObj.drive();
    },

    pedidoModificado() {
      this.actualizarPedidos();
    },
    setTransfers(transfersRecibidos) {
      this.transfers = transfersRecibidos;
    },
    pedidoEntregado() {
      this.getPedidosCerrados();
    },
    async getPedidos() {
      try {
        const response = await axios.get(`/pedidos/get_abiertos`);
        this.items = response.data;
        this.selectedOption = "abiertos";
      } catch (error) {
        console.error(error);
      }
    },
    async actualizarPedidos() {
      try {
        const response = await axios.get(`/pedidos/get_abiertos`);
        this.items = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getPedidosCerrados() {
      try {
        const response = await axios.get(`/pedidos/get_cerrados`);
        this.itemsCerrados = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getUsuarios() {
      try {
        const response = await axios.get(`/usuarios/get_usuarios`);
        this.usuarios = response.data.usuarios;
      } catch (error) {
        console.error(error);
      }
    },
    async getClientes() {
      try {
        const response = await axios.get(`/clientes/get_nombres`);
        this.clientes = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getProductos() {
      try {
        const response = await axios.get(`/productos/get_lista`);
        this.productos = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getPermisoAgregarPrepedido() {
      try {
        const response = await axios.get(`/usuarios/yo`);
        // Separar el string en partes usando espacio como delimitador
        const permisos = response.data.permisos.split(" ");

        // Definir los sufijos buscados
        const sufijosBuscados = [
          ":pedidos:crear",
          "pedidos:crear_ageno",
          ":ADMINISTRADOR",
        ];

        // Comprobar si alguna parte termina con alguno de los sufijos buscados
        const algunaParteTerminaConSufijo = permisos.some((parte) =>
          sufijosBuscados.some((sufijo) => parte.endsWith(sufijo))
        );

        // algunaParteTerminaConSufijo será true si alguna parte termina con "_existencia", de lo contrario, será false
        // console.log(algunaParteTerminaConSufijo);
        this.permisoAreaTrabajo = algunaParteTerminaConSufijo;
      } catch (error) {
        console.error(error);
      }
    },
    recibirPedidosActualizados(nuevosPedidos) {
      this.items = nuevosPedidos;
    },
  },
  async created() {
    this.getUsuarios();
    this.getPedidos();
    this.getPedidosCerrados();
    this.getClientes();
    this.getProductos();
    this.getPermisoAgregarPrepedido();

    // Establece un temporizador para llamar a getPedidos() cada cierto intervalo (por ejemplo, cada 5 segundos)
    // this.timer = setInterval(async () => {
    //   await this.getPedidos();
    // }, 10000); // 5000 milisegundos = 5 segundos
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted() {},
  computed: {
    ...mapGetters(["user"]),
    ...mapGetters(["currentUser"]),
    esAdmin() {
      const permisos = Array.isArray(this.currentUser.permisos)
        ? this.currentUser.permisos
        : (this.currentUser.permisos || "").split(" ");
      //console.log("Permisos del usuario:", permisos);
      return permisos.some((permiso) => permiso.endsWith("ADMINISTRADOR"));
    },
    esSucursal() {
      const permisos = Array.isArray(this.currentUser.permisos)
        ? this.currentUser.permisos
        : (this.currentUser.permisos || "").split(" ");
      //console.log("Permisos del usuario:", permisos);
      return permisos.some(
        (permiso) =>
          permiso.endsWith("ADMINISTRADOR") ||
          permiso.endsWith("Ensenada:pedidos:confirmacion") ||
          permiso.endsWith("LaPaz:pedidos:confirmacion") ||
          permiso.endsWith("Hermosillo:pedidos:confirmacion") ||
          permiso.endsWith("Obregon:pedidos:confirmacion")
      );
    },

    esSucursal2() {
      const permisos = Array.isArray(this.currentUser.permisos)
        ? this.currentUser.permisos
        : (this.currentUser.permisos || "").split(" ");
      //console.log("Permisos del usuario:", permisos);
      return permisos.some(
        (permiso) =>
          permiso.endsWith("ADMINISTRADOR") ||
          permiso.endsWith("Mexicali:pedidos:confirmacion") ||
          permiso.endsWith("Tijuana:pedidos:confirmacion")
      );
    },
  },
  components: {
    PedidosAbiertosTable,
    AreaTrabajo,
    PedidosCerradosTable,
    TransfersComponent,
    //PedidosConfirmados,
    PedidosConfirmacion,
    PedidosConfirmados2,
    PedidosFacturacion,
    PedidosRuta,
    //PedidosPreparacion,
  },
};
</script>
<style>
.disabled-button {
  opacity: 0.3;
}
.enabled-button {
  pointer-events: none;
}

.glass-effect {
  background: rgba(25, 118, 210, 0.3);
  backdrop-filter: blur(10px);
  border-radius: 10px;
  color: #fff;
}

.driver-popover.glass-effect .driver-popover-next-btn,
.driver-popover.glass-effect .driver-popover-prev-btn {
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.8);
  color: #000;
  border: none;
  padding: 10px 15px;
}

.driver-popover.glass-effect .driver-popover-close-btn {
  background: rgba(255, 255, 255, 0.8);
  color: #000;
  margin: 5px;
  border-radius: 20px;
  border: none;
}

.driver-popover.glass-effect .driver-popover-progress-text {
  color: #fff;
  border-radius: 20px;
}
</style>
